var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"spring","mode":"out-in","appear":""}},[_c('div',{staticClass:"popup-menu",attrs:{"id":"js-popup-menu"}},[_c('UserCard',{attrs:{"user-avatar":_vm.user.avatar}}),_c('MenuItems')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }